import { FC, memo } from 'react';
// Import Components
import BonusInfoModalBody from 'components/BonusModal/BonusInfoModalBody';
// Import Hooks
import useBonusById from 'hooks/UseBonusById';
// Import Constants
import { l } from 'constants/common';

interface Props {
    bonusId: Nilable<number>;
}

const BonusBlockInfo: FC<Props> = ({ bonusId }) => {
    const { bonusData, isLoading } = useBonusById(bonusId);

    return (
        <BonusInfoModalBody
            id={bonusData?.Id}
            title={bonusData?.Name}
            description={bonusData?.Description}
            type={bonusData?.Type}
            startDate={bonusData?.StartDate}
            endDate={bonusData?.EndDate}
            bonusDetails={bonusData?.BonusDetails ?? []}
            wallet={bonusData?.BalanceType}
            isLoading={isLoading}
            sectionTitle={l.BonusInfoSectionTitle}
        />
    );
};

export default memo(BonusBlockInfo);
